<template>
  <div class="row page-selector d-block d-md-none d-lg-none mb-5">
    <div class="col-12">
      <b-form-select
        class="custom-select"
        v-model="selected"
        :options="optionsZh"
        @change="changePage(selected)"
        v-if="$i18n.locale == 'zh'"
      ></b-form-select>
      <b-form-select
        class="custom-select"
        v-model="selected"
        :options="options"
        @change="changePage(selected)"
        v-else
      ></b-form-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "GvPageSelector",
  // props: {},
  data() {
    return {
      options: [
        {
          value: "GlobalVisibility-MissYouToo",
          text: "#MissYouToo",
        },
        { value: "GlobalVisibility-360", text: "360 Hong Kong Moments" },
        { value: "GlobalVisibility-Mega", text: "Mega Events" },
        { value: "GlobalVisibility-Super", text: "Hong Kong Super Fans" },
      ],
      optionsZh: [
        {
          value: "GlobalVisibility-MissYouToo",
          text: "#MissYouToo",
        },
        { value: "GlobalVisibility-360", text: "360 Hong Kong Moments：全新視角" },
        { value: "GlobalVisibility-Mega", text: "盛事活動" },
        { value: "GlobalVisibility-Super", text: "香港超級粉絲" },
      ],
      selected: String,
    };
  },
  methods: {
    changePage(selected) {
      this.$router.push({ name: selected });
    },
  },
  // computed: {},
  // beforeMount: function() {},
  mounted: function() {
    this.selected = this.$route.name;
  },
};
</script>

<style></style>
